module.exports = __webpack_public_path__ + "img/85.459e316e.jpg";